<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu
      activeNav="Attendees"
      childName="View Attendees"
    ></side-menu>

    <div class="content">
      <div class="dashboard">
        <heading v-if="event" title="Attendees"></heading>

        <!-- <button class="btn">
          <img class="white_icon" src="@/assets/img/plus.svg" />Attendees
        </button> -->
        <h5>Ticket Type</h5>
        <div class="selector-search">
          <v-select
            id="selector-inp"
            v-model="selectedOption"
            @input="filterByTicket"
            label="name"
            :options="ticket_options"
          />
          <input
            v-model="searchValue"
            @input="filterByName"
            style=""
            id="search-inp"
            type="text"
            placeholder="Search name"
          />
        </div>
        <div>
          <button @click="showImportPopup = true" class="btn text_btn">
            Import
          </button>
          <input
            style="display: none"
            ref="upload"
            type="file"
            class="hide_upload"
            @change="inputFile"
            accept=".xlsx, .xls, .csv"
          />
          <popup title="Select Status of Guests" :show="showImportPopup">
            <v-select v-model="selectedStatus" :options="statusOptions" />

            <div class="btns">
              <button @click="closeImportPopup" class="btn">Continue</button>
            </div>
          </popup>
        </div>
        <table>
          <thead>
            <td>First Name</td>
            <td>Last Name</td>
            <td>Ticket Type</td>
            <td>Payment Status</td>
            <td>Actions</td>
          </thead>
          <tbody>
            <tr v-for="attendee in tableData" :key="attendee.id">
              <td data-label="First Name">{{ attendee.first_name }}</td>
              <td data-label="Last Name">{{ attendee.last_name }}</td>
              <td data-label="Ticket Type">{{ attendee.ticket.name }}</td>
              <td data-label="Payment Status">{{ attendee.status }}</td>
              <td data-label="Action">
                <div class="settings">
                  <!-- <img
                        @click="deleteVenue(venue.id)"
                        src="@/assets/img/trash.svg"
                      /> -->
                  <img
                    width="30px"
                    @click="openPopup(attendee)"
                    src="@/assets/img/settings.svg"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <popup v-if="selectedAttendee" title="Attendee" :show="showPopup">
      <div>
        <p>
          Name:
          {{ `${selectedAttendee.first_name} ${selectedAttendee.last_name}` }}
        </p>
        <p>
          Email: {{ selectedAttendee.email ? selectedAttendee.email : "N/A" }}
        </p>
        <p>
          Company:
          {{ selectedAttendee.company ? selectedAttendee.company : "N/A" }}
        </p>
        <p>Ticket: {{ selectedAttendee.ticket.name }}</p>
        <p>Status: {{ selectedAttendee.status }}</p>
        <p>
          Registered Date:
          {{ selectedAttendee.register_date | format_date_time }}
        </p>
      </div>
    </popup>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";
import XLSX from "xlsx";
import Popup from "@/components/Popup.vue";
import Swal from "sweetalert2";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const functions = fb.default.functions;
var moment = require("moment");

export default {
  name: "events",
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    heading: Title,
    popup: Popup,
  },
  data() {
    return {
      showImportPopup: false,
      showPopup: false,
      event: null,
      loading: false,
      ticket_options: [],
      tableData: [],
      statusOptions: ["REGISTERED", "INVITED"],
      selectedOption: null,
      attendees: [],
      searchValue: "",
      progress: "0%",
      selectedStatus: "INVITED",
      selectedAttendee: null,
      importCSV: functions.httpsCallable("ImportGuestList"),
    };
  },
  firestore() {
    return {
      event: db.collection("event").doc(this.$route.params.id),
      attendees: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("guest"),
    };
  },
  watch: {
    attendees() {
      this.tableData = this.attendees;
    },
  },
  computed: {},
  created() {
    db.collection("event")
      .doc(this.$route.params.id)
      .collection("ticket")
      .get()
      .then((snapshot) => {
        this.ticket_options = snapshot.docs.map((d) =>
          Object.assign({ id: d.id, name: d.data().name })
        );
      });
  },
  methods: {
    openPopup(item) {
      this.showPopup = true;
      this.selectedAttendee = item;
    },
    closePopup() {
      this.showPopup = false;
      this.selectedAttendee = null;
    },
    filterByTicket() {
      this.tableData = this.selectedOption
        ? this.attendees.filter((a) => a.ticket.id == this.selectedOption.id)
        : this.attendees;
    },
    filterByName() {
      this.tableData = this.searchValue
        ? this.attendees.filter((a) => {
            let name = a.first_name + " " + a.last_name;
            return name.toLowerCase().includes(this.searchValue.toLowerCase());
          })
        : this.attendees;
    },
    inputFile(event) {
      let file = event.target.files[0];
      let reader = new FileReader();

      reader.readAsArrayBuffer(file);
      reader.onload = (e) => {
        this.loading = true;
        let data = e.target.result;
        data = new Uint8Array(data);
        this.importCSV({
          uid: this.$store.state.user.uid,
          data: data,
          event_id: this.$route.params.id,
          status: this.selectedStatus,
        })
          .then((res) => {
            this.loading = false;
            event.target.files = null;
            Swal.fire(
              "Import Completed",
              "Your data has been converted and saved",
              "success"
            );
          })
          .catch((err) => {
            Swal.fire(
              "Error!",
              "An error has occured please try again later " + err,
              "error"
            );
          });
      };
    },
    closeImportPopup() {
      this.showImportPopup = false;
      this.$refs.upload.click();
    },

    // filter() {
    //   this.tableData =
    //     this.selectedOption || this.searchValue
    //       ? this.attendees.filter(
    //           (a) =>
    //             (this.selectedOption &&
    //               this.searchValue &&
    //               a.ticket.id == this.selectedOption.id &&
    //               a.name
    //                 .toLowerCase()
    //                 .includes(this.searchValue.toLowerCase())) ||
    //             a.ticket.id == this.selectedOption.id ||
    //             a.name.toLowerCase().includes(this.searchValue.toLowerCase())
    //         )
    //       : this.attendees;
    // },
  },
};
</script>

<style lang="scss">
.selector-search {
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
  #selector-inp {
    width: 35%;
    padding-right: 20px;
  }

  #search-inp {
    width: 35%;
    padding: 2px 0 2px 10px;
  }
}

.hide_upload {
  position: fixed;
  z-index: -2;
  width: 0 !important;
}

.page.event-management {
  background: #f7f7f7;
}

@media screen and (max-width: 700px) {
  .selector-search {
    display: flex;
    flex-direction: column;
    #search-inp {
      width: 100%;
      margin: 20px 0;
    }
    #selector-inp {
      width: 100% !important;
      padding-right: unset !important;
    }
  }
}

.popup {
  .inputs {
    height: 345px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 10px 30px 10px;
  }
  .input {
    width: 48%;
    input {
      padding: 10px !important;
    }
  }
  .error {
    font-weight: bold;
    color: red;
  }
}
</style>
